import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { OptionObject } from 'src/app/core/utils/type';

@Component({
  selector: 'app-option',
  templateUrl: './option.component.html',
  styleUrls: ['./option.component.scss'],
})
export class OptionComponent implements OnInit {
  @Input() isSelected: boolean = false;
  isHighlighted: boolean = false;
  @Input() classNames: string = '';
  @Input() classNameForVariant: string = '';
  @Input() value: string = '';
  @Input() label: string = '';
  option: OptionObject = {
    label: '',
    value: '',
  };
  @Output() selectEvent = new EventEmitter<OptionObject>();

  constructor() {}

  ngOnInit(): void {}

  handleSelect(): void {
    this.option.label = this.label;
    this.option.value = this.value;
    this.selectEvent.emit(this.option);
  }
}
